import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';

import { PedidoFechamento } from '../models/pedido-fechamento';
import { Fornecedor } from '../models/fornecedor';
import { FechamentoFinanceiro } from '../models/fechamento-financeiro';

import { FechamentoFinanceiroService } from '../services/fechamento-financeiro.service';
import { FornecedorService } from '../services/fornecedor.service';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { GlobalService } from '../services/global.service';
import { UtilitarioService } from '../services/utilitario.service';

import { StatusDoFechamento } from '../models/enum';
import { ProdutoPedidoModalComponent } from '../modals/produto-pedido-modal/produto-pedido-modal.component';
import { PremissasService } from '../services/premissas.service';
import { UsuarioLogado } from '../models/usuario-logado';

declare const $: any;

@Component({
  selector: 'app-fechamento-financeiro',
  templateUrl: './fechamento-financeiro.component.html',
  styleUrls: ['./fechamento-financeiro.component.scss']
})
export class FechamentoFinanceiroComponent implements OnInit {
  fornecedores: Fornecedor[] = [];
  pedidos: PedidoFechamento[] = [];
  valorTotal: number = 0;
  valorTotalSelecionados: number = 0;
  checarTodos = false;
  fornecedorSelecionado: number;
  verExcel = false;
  usuarioLogado: UsuarioLogado;

  constructor(
    private fornecedorService: FornecedorService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private fechamentoFinanceiroService: FechamentoFinanceiroService,
    private router: Router,
    public dialog: MatDialog,
    private globalService: GlobalService,
    private utilitarioService: UtilitarioService,
    private premissasService: PremissasService
  ) { }

  async ngOnInit() {

    this.usuarioLogado = await this.globalService.consultaUsuario();

    this.carregandoService.mostra('consultarMultiFornecedores');
    this.premissasService.consultarMultiFornecedores().subscribe(f => {
      if (!f.valor) {
        this.router.navigate(['/']);
      } else {
        this.buscarFornecedores();
      }
      this.carregandoService.esconde('consultarMultiFornecedores');
    }, (erro) => {
      this.carregandoService.esconde('consultarMultiFornecedores');
      this.notificacaoService.erro(erro);
    });

    this.verExcel = this.usuarioLogado.verExcel;
  }

  buscarPedidos() {
    this.carregandoService.mostra('buscarPedidos');

    this.fechamentoFinanceiroService.consultarPedidosParaFechar(this.fornecedorSelecionado).subscribe(
      (pedidos) => {
        this.pedidos = pedidos;
        this.checarTodos = false;
        this.valorTotal = 0;
        this.valorTotalSelecionados = 0;
        this.valorTotal = this.pedidos.reduce((acc, curr) => acc += curr.valorPedido, 0);

        this.carregandoService.esconde('buscarPedidos');
      },
      (err) => {
        this.carregandoService.esconde('buscarPedidos');
        this.notificacaoService.erro(err);
      }
    );
  }

  checarTodosToggle() {
    this.pedidos.forEach(p => p.checado = this.checarTodos);
    this.atualizarValorSelecionado();
  }

  atualizarValorSelecionado() {
    this.valorTotalSelecionados = 0;

    this.valorTotalSelecionados = this.pedidos.reduce((acc, curr) => acc += curr.checado ? curr.valorPedido : 0, 0);
  }

  buscarFornecedores() {
    this.carregandoService.mostra('buscarFornecedores');

    this.fornecedorService.consultarFornecedores().subscribe(
      (forn) => {
        this.fornecedores = forn;
        this.carregandoService.esconde('buscarFornecedores');
      },
      (err) => {
        this.carregandoService.esconde('buscarFornecedores');
        this.notificacaoService.erro(err);
      }
    );
  }

  abrirModalDetalhes(pedido: PedidoFechamento) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(ProdutoPedidoModalComponent, {
      width: largura > 1150 ? '1100px' : (($('body').width()).toString() + 'px'),
      data: { idCupom: pedido.idCupom },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  buscarPedidosSelecionados() {
    return this.pedidos.filter(p => p.checado).map(p => p.idCupom);
  }

  validarFechamento(): boolean {
    return this.buscarPedidosSelecionados().length > 0 && this.fornecedorSelecionado !== null && this.fornecedorSelecionado !== undefined;
  }

  criarFechamento() {
    const novoFechamento = new FechamentoFinanceiro();

    novoFechamento.data = new Date();
    novoFechamento.idFuncionario = this.usuarioLogado.id;
    novoFechamento.funcionario = this.usuarioLogado.nome;
    novoFechamento.idFornecedor = this.fornecedorSelecionado;
    novoFechamento.fornecedor = this.fornecedores.find(p => p.id === this.fornecedorSelecionado).descricao;
    novoFechamento.pedidos = this.buscarPedidosSelecionados();
    novoFechamento.valor = this.valorTotalSelecionados;
    novoFechamento.status = StatusDoFechamento.EmAnalise;
    novoFechamento.dataStatus = new Date();

    this.router.navigate(['fechamento-financeiro/novo'],
      {
        state: {
          fechamento: novoFechamento
        }
      });
  }

  consultaFechamento() {
    this.router.navigate(['fechamento-financeiro/consulta']);
  }

  exportar() {
    this.carregandoService.mostra('exportar');
    this.fechamentoFinanceiroService.exportarPedidosParaFechar(this.fornecedorSelecionado).subscribe(
      (arq) => {
        this.utilitarioService.saveBlob(arq, 'PedidosParaFechar.xlsx');
        this.carregandoService.esconde('exportar');
      },
      (err) => {
        this.carregandoService.esconde('exportar');
        this.notificacaoService.erro(err);
      }
    );
  }

  ordena(campo) {
    return false;
  }

}
